module.exports = __webpack_public_path__ + "static/img/14001015.1bb7aaf2.png";